
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M16.613 51h21.74M52.5 41.993c0 1.244-.972 2.25-2.174 2.25H4.674c-1.198 0-2.174-1.006-2.174-2.25V8.25C2.5 7.006 3.476 6 4.674 6h45.652C51.528 6 52.5 7.006 52.5 8.25v33.743zm-28.244 2.258V51m6.522-6.749V51"}}),_c('path',{attrs:{"d":"M28.57 27.38l15.217-6.75-15.218-6.748-15.217 6.749 15.217 6.748z"}}),_c('path',{attrs:{"d":"M19.874 24.006v7.873l8.696 4.5 8.696-4.5v-7.873m-23.914-3.375v7.874m.035-.018l-2.174 6.749h4.348l-2.174-6.749z"}})])])
          )
        }
      }
    